export default __webpack_public_path__ + "static/media/portfolio-hover-172.830a295e.jpg";